export const PageLabels: { [key: string]: string } = {
  [`/`]: '홈',
  [`/terms`]: '이용약관',
  [`/privacy`]: '개인정보처리방침',

  [`/search`]: '검색',
  [`/chat`]: '채팅',
  [`/chats`]: '채팅',
  [`/lounge`]: '라운지',
  [`/lounge/:userContentId`]: '라운지 상세',
  [`/lounge/profile`]: '라운지 프로필',
  [`/commerce`]: '쇼핑',
  [`/events`]: '이벤트',
  [`/events/:eventAlias`]: '이벤트 상세',
  [`/my-page`]: '마이페이지',
  [`/join/referral`]: '친구초대',
  [`/join/membership/:membershipAlias`]: '멤버십 가입',
  [`/join`]: '회원가입',

  [`/login/email`]: '이메일 로그인',
  [`/my-page/settings`]: '계정설정',
  [`/my-page/app-settings`]: '앱 설정',
  [`/collection`]: '컬렉션',
  [`/collection/:collectionId`]: '컬렉션',
  [`/commerce/collection`]: '쇼핑',
  [`/class/collection`]: '클래스',
  [`/theme/collection`]: '테마컬렉션',
  [`/product/:productId`]: '상품상세',
  [`/my-page/tutor-profile`]: '강사정보 수정',
  [`/my-page/user-profile`]: '내 정보 수정',
  [`/my-page/user-profile/password`]: '비밀번호 변경',
  [`/my-page/user-profile/phone`]: '연락처 변경',
  [`/my-page/user-profile/address`]: '주소 변경',
  [`/my-page/user-profile/category`]: '관심사 변경',
  [`/my-page/user-profile/account`]: '정산계좌 변경',
  [`/my-page/user-profile/name`]: '이름 변경',
  [`/my-page/user-profile/child`]: '자녀정보 변경',

  [`/tutor-info/:tutorId`]: '강사정보',
  [`/partner/:partnerId`]: '파트너정보',
  [`/my-page/settlements`]: '정산내역',
  [`/my-page/favorite`]: '찜',
  [`/my-page/favorite/:tab`]: '찜',
  [`/my-page/schedule`]: '내수업',
  [`/my-page/class-management`]: '수업관리',
  [`/my-page/report-management`]: '리포트 관리',
  [`/my-page/report-management/:programReportId`]: '리포트 상세',
  [`/my-page/purchase`]: '결제내역',
  [`/my-page/purchase/refund`]: '환불요청',
  [`/my-page/purchase/purchase-detail`]: '결제상세',
  [`/my-page/class-invoices`]: '청구서 관리',
  [`/my-page/program-schedules`]: '수업 스케쥴',
  [`/my-page/coupon`]: '쿠폰함',
  [`/my-page/reward`]: '리워드',
  [`/my-page/point`]: '포인트',
  [`/my-page/notice`]: '공지사항',
  [`/my-page/policy`]: '약관 및 정책',
  [`/notice/:noticeId`]: '공지사항 상세',
  [`/alarm`]: '알림',
  [`/program-invoices/:programInvoiceId`]: '청구서 보기',
  [`/class-report/edit`]: '수업 리포트 수정',
  [`/class-report/view`]: '수업 리포트 보기',
};
